import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';

const MainLayout = () => {
  const [theme, setTheme] = useState('dark');

  const handleThemeChange = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
    document.documentElement.classList.toggle('dark', theme !== 'dark');
  };

  return (
    <div className={`min-h-screen flex flex-col ${theme}`}>
      <Header />
      <main className="flex-grow pt-28">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
